import { render, staticRenderFns } from "./QuestionGroup.vue?vue&type=template&id=6a3b517d&scoped=true&"
import script from "./QuestionGroup.vue?vue&type=script&lang=js&"
export * from "./QuestionGroup.vue?vue&type=script&lang=js&"
import style0 from "./QuestionGroup.vue?vue&type=style&index=0&id=6a3b517d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3b517d",
  null
  
)

export default component.exports